/* eslint eqeqeq: 0 */
import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
import { getStatusColor } from "utils/statusColors.js";
export const statusStyle = {
  statusColorStyle: statusColorStyleMethod,
};
function statusColorStyleMethod(status, props, color) {
  let statusColor = color ? color : getStatusColor(status);
  return {
    default: {
      background: statusColor,
      fontSize: props.forDashboard ? "10px" : "12px",
      padding: props.forDashboard ? "0px" : "5px",
      textAlign: "center",
      margin: "15px",
      borderRadius: "4px",
      color: basicColors.fourth,
    },
    retro: {
      minWidth: "fit-content",
      fontSize: props.forDashboard ? "10px" : "12px",
      padding: props.forDashboard ? "0px" : "5px",
      textAlign: "center",
      margin: "15px",
      borderRadius: "0px",
      color: "var(--second)",
      border: "1px solid" + statusColor,
      borderLeft: "6px Solid" + statusColor,
      borderImage: "none",
    },
    electric: {
      fontSize: props.forDashboard ? "10px" : "12px",
      padding: props.forDashboard ? "0px" : "5px",
      textAlign: "center",
      margin: "15px",
      borderRadius: "0px",
      color: electricColors.second,
      border: "1px solid" + statusColor,
      borderLeft: "6px Solid" + statusColor,
      borderImage: "none",
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/JourneyPlan/JourneyPlanList/style/index.js